import PropTypes from 'prop-types';
import { forwardRef } from 'react';
import { twJoin, twMerge } from 'tailwind-merge';

import Icon from 'shopper/components/Icon';
import Text from 'shopper/components/Text';

import STEP_TYPES from 'constants/stepper';

const CLASSNAMES_BY_TYPE = {
  [STEP_TYPES.CURRENT]: {
    border: 'border-neutral-high-300 dark:border-neutral-low-100',
    background: null,
    foreground: 'text-neutral-low-300 dark:text-neutral-high-200',
    iconColor:
      'text-neutral-low-300 bg-neutral-low-300 dark:text-neutral-high-200 dark:bg-neutral-high-200',
    iconForeground: 'text-neutral-high-100 dark:text-neutral-low-300',
  },
  [STEP_TYPES.NOT_STARTED]: {
    border: 'border-neutral-high-300 dark:border-neutral-low-100',
    background: null,
    foreground: 'text-neutral-high-500 dark:text-neutral-low-100',
    iconColor:
      'text-neutral-high-400 bg-neutral-high-400 dark:text-neutral-high-500 dark:bg-neutral-high-500',
    iconForeground: 'text-neutral-high-100 dark:text-neutral-low-300',
  },
  [STEP_TYPES.COMPLETED]: {
    border: null,
    background: 'bg-success-100',
    foreground: 'text-success-500 dark:text-success-400',
    iconColor: 'text-success-300 dark:text-success-300',
    iconForeground: null,
  },
};

const StepLabel = forwardRef(
  (
    {
      children,
      className,
      position = 1,
      type = STEP_TYPES.NOT_STARTED,
      ...rest
    },
    ref
  ) => (
    <div
      ref={ref}
      className={twMerge(
        'flex items-center rounded-2 px-4 py-3',
        type !== STEP_TYPES.COMPLETED && 'border border-solid',
        CLASSNAMES_BY_TYPE[type].border,
        CLASSNAMES_BY_TYPE[type].background,
        className
      )}
      {...rest}
    >
      {type === STEP_TYPES.COMPLETED ? (
        <Icon
          className={CLASSNAMES_BY_TYPE[type].iconColor}
          name="check-circle"
          size="size1"
        />
      ) : (
        <div
          className={twJoin(
            'flex size-5 items-center justify-center rounded-full',
            CLASSNAMES_BY_TYPE[type].iconColor
          )}
        >
          <Text
            className={CLASSNAMES_BY_TYPE[type].iconForeground}
            size="size2"
            bold
          >
            {position}
          </Text>
        </div>
      )}
      <Text className={twJoin('ml-2', CLASSNAMES_BY_TYPE[type].foreground)}>
        {children}
      </Text>
    </div>
  )
);

StepLabel.displayName = 'StepLabel';

StepLabel.propTypes = {
  children: PropTypes.node.isRequired,
  className: PropTypes.oneOfType([PropTypes.bool, PropTypes.string]),
  position: PropTypes.number,
  type: PropTypes.oneOf(Object.values(STEP_TYPES)),
};

export default StepLabel;
